<template >
	<v-layout >
		<v-container fluid class="subproduct-container" :class="{ 'one-step-menu' : isSingleMenuPage }">
			<template v-if="differentiatedGroup">
				<div v-if="newAddonsFlow && !isSingleMenuPage" class="upsell-wrapper spacing-box product-catalog-carousel">
					<div class="carousel-gradient-start"></div>
					<div class="carousel-gradient-end"></div>
					<carousel
						:per-page="2.5"
						:mouse-drag="true"
						:scrollPerPage="false"
						:center-mode="true"
						:navigationEnabled="true"
						:paginationEnabled="false"
						navigationNextLabel="<v-icon class='v-icon material-icons theme--light'>chevron_right</v-icon>"
						navigationPrevLabel="<v-icon class='v-icon material-icons theme--light'>chevron_left</v-icon>"
					>
						<slide v-for="(product) in differentiatedGroup.products.upsell" :key="product.id">
							<v-flex class="first-subarray real-products">
								<v-layout
									@click="changeSelection(product.id)"
									data-apm-span="subproduct-wrapper"
									class="sub-product-wrapper animation-div"
									:class="{ 'addition-not-selected': highlightedUpsellProducts && additionsProductNotSelected	}"
								>
									<v-img :src="backImg(product)[0]" maintain-aspect class="image-box"  >
										<LabelComponent
											v-if="productHasCustomLabelFn(product)"
											:product="product"
											parentComponent="checkboxGrid"
										/>
										<v-badge
											v-if="productHasDiscountLabelFn(product)"
											class="family-discount-label-wrapper" :class="{'family-discount-label-wrapper-kiosk' : isKioskChannel, 'family-discount-label-long-text':  productHasDiscountLabelWithLongTextFn(product)}"
										>
											{{product.discount.options.productLabel | translate(`priceRule.${product.discount.discountId}.productLabel`)}}
										</v-badge>
										<div class="bottom-wrapper" >
											<v-checkbox
												class="subproduct-checkbox subproduct-burger-checkbox"
												:key="product.id"
												:value="product.id"
												v-model="selectedSubproducts"
												hide-details
												name="subproduct-checkbox"
												data-apm-span="subproduct-checkbox"
												@click.stop="changeSelection(product.id)"
											>
											</v-checkbox>
											<div class="subproduct-name-price">
												<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
													{{ $translate(product.name, `product.${product.id}.name`) }}
												</div>
												<div class="subproduct-price" data-cy="subProductPrice" >
													{{ getSubproductPrice(product) }}
												</div>
											</div>
										</div>
									</v-img>
								</v-layout>
							</v-flex>
						</slide>
					</carousel>
				</div>
				<v-layout v-else row class="upsell-wrapper spacing-box">
					<v-flex
						v-for="(product) in differentiatedGroup.products.upsell"
						:key="product.id"
						class="first-subarray real-products"
					>
						<v-layout
							@click="changeSelection(product.id)"
							data-apm-span="subproduct-wrapper"
							class="sub-product-wrapper animation-div"
							:class="{ 'addition-not-selected': highlightedUpsellProducts && additionsProductNotSelected }"
						>
							<v-flex v-if="isSingleMenuPage" class="sub-product-wrapper">
								<div class="one-step-menu-img">
									<img :src="backImg(product)[0]" />
								</div>
								<div class="bottom-wrapper">
									<div class="subproduct-name-price">
										<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
											{{ $translate(product.name, `product.${product.id}.name`) }}
										</div>
										<div class="subproduct-price" data-cy="subProductPrice" >
											{{ getSubproductPrice(product) }}
										</div>
									</div>
									<v-checkbox
										class="subproduct-checkbox subproduct-burger-checkbox"
										:key="product.id"
										:value="product.id"
										v-model="selectedSubproducts"
										hide-details
										name="subproduct-checkbox"
										data-apm-span="subproduct-checkbox"
										@click.stop="changeSelection(product.id)"
									>
									</v-checkbox>
								</div>
							</v-flex>
							<v-img v-else :src="backImg(product)[0]" maintain-aspect class="image-box"  >
								<LabelComponent
									v-if="productHasCustomLabelFn(product)"
									:product="product"
									parentComponent="checkboxGrid"
								/>
								<v-badge
									v-if="productHasDiscountLabelFn(product)"
									class="family-discount-label-wrapper" :class="{'family-discount-label-wrapper-kiosk' : isKioskChannel, 'family-discount-label-long-text':  productHasDiscountLabelWithLongTextFn(product)}"
								>
									{{product.discount.options.productLabel | translate(`priceRule.${product.discount.discountId}.productLabel`)}}
								</v-badge>
								<div class="bottom-wrapper" >
									<v-checkbox
										class="subproduct-checkbox subproduct-burger-checkbox"
										:key="product.id"
										:value="product.id"
										v-model="selectedSubproducts"
										hide-details
										name="subproduct-checkbox"
										data-apm-span="subproduct-checkbox"
										@click.stop="changeSelection(product.id)"
									>
									</v-checkbox>
									<div class="subproduct-name-price">
										<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
											{{ $translate(product.name, `product.${product.id}.name`) }}
										</div>
										<div class="subproduct-price" data-cy="subProductPrice" >
											{{ getSubproductPrice(product) }}
										</div>
									</div>
								</div>
							</v-img>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout v-if="isBM100 && !isSingleMenuPage" row wrap class="default-wrapper spacing-box" >
					<v-flex
						v-for="(product) in differentiatedGroup.products.default.slice(0, addonsLimit - upsellProductsLength)"
						:key="product.id"
						:class="{'xs6': !isSingleMenuPage, 'xs12' : isSingleMenuPage}"
					>
						<v-layout
							data-apm-span="sub-product-wrapper"
							name="sub-product-wrapper"
							@click="changeSelection(product.id)"
							class="sub-product-wrapper animation-div"
							:class="{'addition-not-selected': highlightedUpsellProducts && additionsProductNotSelected}"
						>
							<v-checkbox
								class="subproduct-checkbox subproduct-burger-checkbox"
								:key="product.id"
								:value="product.id"
								v-model="selectedSubproducts"
								hide-details
								name="subproduct-checkbox"
								data-apm-span="subproduct-checkbox"
								@click.stop="changeSelection(product.id)"
							>
							</v-checkbox>
							<div class="subproduct-name-price">
								<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
									{{ product.name | translate(`product.${product.id}.name`) }}
								</div>
								<div class="subproduct-price" data-cy="subProductPrice">
									{{ getSubproductPrice(product) }}
								</div>
							</div>
						</v-layout>
					</v-flex>
					<v-expansion-panel class="extra-add-ons" v-if="isExtraAddOnsShown">
					<v-expansion-panel-content>
						<template v-slot:header>
							<div>{{ $t("shopComponents.gt3.detailsTemplates_steps.detailsGroups.extraOptionalItems") }}</div>
						</template>
						<v-layout row wrap>
							<v-flex
								v-for="(product) in differentiatedGroup.products.default.slice(addonsLimit - upsellProductsLength)"
								:key="product.id"
								xs6
							>
								<v-layout
									data-apm-span="sub-product-wrapper"
									name="sub-product-wrapper"
									@click="changeSelection(product.id)"
									class="sub-product-wrapper animation-div"
									:class="{'addition-not-selected': highlightedUpsellProducts && additionsProductNotSelected}"
								>
									<v-checkbox
										class="subproduct-checkbox subproduct-burger-checkbox"
										:key="product.id"
										:value="product.id"
										v-model="selectedSubproducts"
										hide-details
										name="subproduct-checkbox"
										data-apm-span="subproduct-checkbox"
										@click.stop="changeSelection(product.id)"
									>
									</v-checkbox>
									<div class="subproduct-name-price">
										<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
											{{ product.name | translate(`product.${product.id}.name`) }}
										</div>
										<div class="subproduct-price" data-cy="subProductPrice">
											{{ getSubproductPrice(product) }}
										</div>
									</div>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-expansion-panel-content>
					</v-expansion-panel>
				</v-layout>
				<v-layout v-else row wrap class="default-wrapper spacing-box" >
					<v-flex
						v-for="(product) in differentiatedGroup.products.default"
						:key="product.id"
						:class="{'xs6': !isSingleMenuPage, 'xs12' : isSingleMenuPage}"
					>
						<v-layout
							data-apm-span="sub-product-wrapper"
							name="sub-product-wrapper"
							@click="changeSelection(product.id)"
							class="sub-product-wrapper animation-div"
							:class="{'addition-not-selected': highlightedUpsellProducts && additionsProductNotSelected}"
						>
							<v-checkbox
								class="subproduct-checkbox subproduct-burger-checkbox"
								:key="product.id"
								:value="product.id"
								v-model="selectedSubproducts"
								hide-details
								name="subproduct-checkbox"
								data-apm-span="subproduct-checkbox"
								@click.stop="changeSelection(product.id)"
							>
							</v-checkbox>
							<div class="subproduct-name-price">
								<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
									{{ product.name | translate(`product.${product.id}.name`) }}
								</div>
								<div class="subproduct-price" data-cy="subProductPrice">
									{{ getSubproductPrice(product) }}
								</div>
							</div>
						</v-layout>
					</v-flex>
				</v-layout>
				<div
					class="addition-selection-text"
					v-if="highlightedUpsellProducts && additionsProductNotSelected"
				>
					{{$t("shopComponents.gt3.productCatalog.productGroupCheckBoxGrid.text")}}
				</div>
			</template>
			<template v-else >
				<v-layout row wrap class="default-wrapper spacing-box" data-cy="subproductSecondGroup" >
					<v-flex
						v-for="product in group.products"
						:key="product.id"
						:class="{'xs6': !isSingleMenuPage, 'xs12' : isSingleMenuPage}"
					>
						<v-layout @click="changeSelection(product.id)" class="sub-product-wrapper" >
							<v-checkbox
								class="subproduct-checkbox subproduct-burger-checkbox"
								:key="product.id"
								:value="product.id"
								v-model="selectedSubproducts"
								hide-details
								name="subproduct-checkbox"
								data-apm-span="subproduct-checkbox"
								@click.stop="changeSelection(product.id)"
							>
							</v-checkbox>
							<div class="subproduct-name-price">
								<div class="subproduct-name" :class="{'checked-text' : product.id === selectedSubproducts}" :data-cy="product.name">
									{{ product.name | translate(`product.${product.id}.name`) }}
								</div>
								<div class="subproduct-price" data-cy="subProductPrice">
									{{ getSubproductPrice(product) }}
								</div>
							</div>
						</v-layout>
					</v-flex>
				</v-layout>
			</template>
		</v-container>
	</v-layout>
</template>

<script >
	import * as Utils from "../../../../libraries/utils";
	import appConfig, {channelEnum} from "../../../../appconfig";
	import mutationTypesBM100 from "../../../../store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";
	import {formatPriceZero, isSpecificProductGroupType} from "../../../../domains2/libraries/Utils";
	import {getBackImages} from "../../../../libraries/utils";
	import LabelComponent from "../../../UtilityComponents/Label";

	import {
		productHasCustomLabel,
		productHasDiscountLabel,
		productHasDiscountLabelWithLongText
	} from "../../../../helper/ProductHelper";
	import {mapGetters} from "vuex";
	import addOnMixin from "../../../../mixins/addOn.mixin";
	import {Carousel, Slide} from "vue-carousel/src";


	export default {
		name: "ProductGroupCheckBoxGrid-gt3",
		props: [
			"highlightedUpsellProducts",
			"additionsProductNotSelected",
			"mainGroup",
			"subProduct",
			"group",
			"index",
			"changeSubGroupProductSelection",
			"productSelections",
			"differentiatedGroup",
			"isMenu",
			"isSingleMenuPage"
		],
		mixins: [addOnMixin],
		components: {LabelComponent, Carousel, Slide},
		data() {
			return {
				selectedSubproducts: [],
				optionsChosen: false
			};
		},
		computed: {
			...mapGetters(["featureToggles", "tenantSettings", "globalSelectedShop"]),
			staticPath() {
				return Utils.getStaticPath();
			},
			upsellProductsLength() {
				return this.differentiatedGroup.products.upsell.length;
			},
			defaultProductsLength() {
				return this.differentiatedGroup.products.default.length;
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			},
			isBM100() {
				return appConfig.isBM100();
			},
			isExtraAddOnsShown() {
				return this.addonsLimit < this.upsellProductsLength + this.defaultProductsLength;
			},
			productSelectionId() {
				return this.$route.params.productSelectionId;
			}
		},
		mounted() {
			const self = this;
			if(self.subProduct !== null) {
				const selectedProducts = self.productSelections[self.index].groups
					.find(g => g.groupId === self.mainGroup.id).selectedProducts;
				self.selectedSubproducts = selectedProducts.find(s => s.groups.find(g => g.groupId === self.group.id) !== null).groups
					.find(g => g.groupId === self.group.id).selectedProducts;
			} else {
				self.selectedSubproducts = [...self.productSelections[self.index].groups.find(g => g.groupId === self.group.id).selectedProducts];
			}
		},
		methods: {
			calculateDifference(price) {
				const self = this;
				const defaultSelectedProduct = self.group.products.find(product => product.id === self.group.options.defaultSelected);
				if (defaultSelectedProduct) {
					return price - defaultSelectedProduct.getPriceInGroup();
				} else {
					return price;
				}
			},
			formatPriceZero,
			isSpecificProductGroupType,
			productHasDiscountLabelFn(product) {
				return productHasDiscountLabel(product);
			},
			productHasCustomLabelFn(product) {
				return productHasCustomLabel(product);
			},
			productHasDiscountLabelWithLongTextFn(product) {
				return productHasDiscountLabelWithLongText(product);
			},
			showImage(product) {
				return product.imageLinks && product.imageLinks.length;
			},
			backImg(product) {
				return getBackImages(product, this.isKioskChannel, false);
			},
			changeSelection(productId, shouldClearSelection = false) {
				const self = this;
				if(!this.isMenu && this.$store.getters.featureToggles.showFlexibleIngredientsOptions) {
					const activeSelection = this.$store.getters.activeProductSelections
						.find(s => s.productSelectionId === this.productSelectionId);
					const groupToAppendIngredient = activeSelection.groups && activeSelection.groups.find(g => g.appearance === "checklist");
					if(activeSelection && groupToAppendIngredient) {
						const activeSelectedProducts = groupToAppendIngredient.selectedProducts;
						// we have to bring selected products from active selection to have ingredients as a part of
						// product selection in the first group (additions)
						// otherwise it gets overwritten when something is selected in this component
						// using Set to ensure that there is no duplicates from "checkbox" group
						self.selectedSubproducts = Array.from(new Set([
							...self.selectedSubproducts,
							...activeSelectedProducts
						]));
					}
				}
				if(shouldClearSelection) {
					self.selectedSubproducts.splice(0);
				}
				if(self.selectedSubproducts.includes(productId)) {
					self.selectedSubproducts.splice(self.selectedSubproducts.indexOf(productId), 1);
				} else {
					if(self.differentiatedGroup) {
						if(self.highlightedUpsellProducts) {
							self.$store.commit(mutationTypesBM100.HIGHLIGHT_UPSELL_PRODUCTS, false);
						}
					}
					self.selectedSubproducts.push(productId);
				}
				self.changeSubGroupProductSelection(
					self.mainGroup,
					self.subProduct,
					self.group,
					self.selectedSubproducts
				);

			},
			getSubproductPrice(product) {
				const price = isNaN(parseFloat(product.price)) ? 0 : parseFloat(product.price);
				if (price > 0) {
					return "+" + formatPriceZero(price);
				}
			}
		}
	};
</script>

<style scoped lang="scss" >
	.subproduct-container{
		padding: 0;
		.sub-product-wrapper{
			height: 110px;
			border-radius: 5px;
			border: solid 3px #26282c;
			background-color: #191a1b;
			margin-top: 20px;
			.subproduct-burger-checkbox{
				justify-content: center;
				align-items: center;
				padding: 0;
				max-width: 79px;
			}
			.subproduct-name-price{
				font-family: Dispatch;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.36;
				letter-spacing: normal;
				color: #ffffff;
				.subproduct-name{
					font-weight: bold;
					padding-top: 31px;
					text-transform: uppercase;
				}
				.subproduct-price{
					padding-top: 12px;
					text-align: left;
				}
			}
		}
		.upsell-wrapper {
			margin-top: 20px;
			/deep/.product-label-wrapper {
				position: absolute;
			}
			.first-subarray.real-products {
				width: 40% !important;
				min-width: 187px;
			}
			.first-subarray {
				max-width: 100% !important;
				width: auto;

				.sub-product-wrapper {
					position: relative;
					z-index: 1;
					height: 100% !important;
					margin-top: 0 !important;
					.image-box {
						opacity: 0.5;
						width: 100%;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.subproduct-burger-checkbox, .subproduct-name-price {
						z-index: 1;
						display: flex;
						align-items: center;
						width: 100%;
						padding-right: 16px;
					}

					.subproduct-name, .subproduct-price {
						padding-top: 0;
						width: 100%;
					}

					.subproduct-price {
						text-align: right;
					}
				}
			}
			&.product-catalog-carousel {
				position: relative;
				margin: 20px 20px 0 20px;
				.first-subarray.real-products {
					width: 100% !important;
					height: 100%;
					&:first-child {
						padding-left: 0;
					}
				}
				/deep/ .VueCarousel-navigation-button {
					border: 3px solid #FFFFFF;
					border-radius: 50%;
					width: 44px;
					height: 44px;
					.v-icon {
						color: #FFFFFF;
						font-size: 30px;
						width: 20px;
						height: 20px;
					}
				}
				.carousel-gradient-start {
					width: 43px;
					height: 100%;
					position: absolute;
					background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0, 0, 0, 0) 100%);
					z-index: 2;
					left: -1px;
				}
				.carousel-gradient-end {
					width: 43px;
					height: 100%;
					position: absolute;
					right: -1px;
					background: linear-gradient(270deg, rgba(0,0,0,1) 0%, rgba(0, 0, 0, 0) 100%);
					z-index: 2;
				}
				@media (max-width: 1537px) {
					/deep/ .VueCarousel-navigation-button {
						z-index: 3;
						&.VueCarousel-navigation-next {
							right: 35px;
						}
						&.VueCarousel-navigation-prev {
							left: 35px;
						}
					}
				}
			}
		}
		.addition-selection-text {
			position: absolute;
			font-size: 16px;
			padding-top: 4px;
			color: #FFD800;
			padding-left: 22px;
		}
		.upsell-wrapper {
			.subproduct-burger-checkbox, .subproduct-name-price {
				padding-bottom: 30px;
				align-items: flex-end !important;
				justify-content: space-between;
			}
			.subproduct-burger-checkbox {
				padding-left: 24px !important;
			}
			.subproduct-price {
				width: auto !important;
			}
			.image-box {
				opacity: 1 !important;
			}
			.no-thanks {
				//max-width: 230px;
			}
			.sub-product-wrapper {
				height: auto !important;
			}
		}
	}
	.family-discount-label-wrapper {
		color: black;
		background-color: #ffd800;
		font-size: 28px;
		margin: 16px;
		padding: 10px 40px 8px;
		border: 3px solid black;
		border-radius: 60px;
		font-family: "Dispatch-Black";
		letter-spacing: 1px;
		z-index: 1;
	}
	.family-discount-label-wrapper-kiosk {
		font-size: 20px;
		margin: 10px;
		padding: 7px 28px 5px;
	}

	.v-expansion-panel.extra-add-ons {
		margin-top: 40px;
		.v-expansion-panel__container {
			background-color: #000;
			/deep/.v-expansion-panel__header {
				background-color: #161616;
				margin: 0 20px;
				height: 42px;
				line-height: 42px;
				font-size: 20px;
				color: #9b9b9b;
				font-family: Dispatch;
				border-radius: 3px;
				min-height: 42px;
				font-weight: bold;
				text-transform: uppercase;
			}
			/deep/.v-expansion-panel__header__icon .v-icon {
				color: #9b9b9b;
			}
		}
	}
</style>
